
export const ADD_MDF_WHITE = "ADD_MDF_WHITE"
export const DELETE_MDF_WHITE = "DELETE_MDF_WHITE"
export const GET_MDF_WHITE = "GET_MDF_WHITE"

export const GET_MDF_COLOR = "GET_MDF_COLOR"
export const GET_DETAILS_MDF_COLOR = "GET_DETAILS_MDF_COLOR"
export const GET_LIST_MDF_COLOR = "GET_LIST_MDF_COLOR"
export const SEND_FORM = "SEND_FORM"
export const SEND_EDIT_FORM = "SEND_EDIT_FORM "
export const GET_ALL_LIST_MDF = "GET_ALL_LIST_MDF"
export const SEND_CHAT = "SEND_CHAT"
export const SEND_CHAT_TICKET = "SEND_CHAT_TICKET"
export const GET_CHAT = "GET_CHAT"
export const GET_CHAT_TICKET = "GET_CHAT_TICKET"
export const GET_IMAGE_MDF = "GET_IMAGE_MDF"
export const GET_FINAL_LIST_MDF = "GET_FINAL_LIST_MDF"
export const GET_CATEGORY = "GET_CATEGORY"


import config from "../../constants/config"

import FormData from "form-data"
import axios from "axios";
import { Platform } from "react-native"


export const getcategory = (access_token) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/app/category-order";
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                // console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_CATEGORY, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};





export const Deletewhite = (access_token, ids) => {

    return async (dispatch) => {


        const Header = {

            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        }

        var formdata = new FormData();
        formdata.append("product_id", ids);


        var requestOptions = {
            method: 'POST',
            headers: Header,
            body: formdata,
        };

        return fetch("https://npln.ir/api/v1/user/delete-white", requestOptions)
            .then(response => response.json())
            .then(res => {
                //console.log(res);

                const data = res
                dispatch({ type: DELETE_MDF_WHITE, data });
                return res;
            })

            .catch(error => console.log('error', error));
    };
}


export const getMdfWhite = (access_token) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/user/white-products";
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_MDF_WHITE, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};






export const getMdfColor = (access_token, offset, name) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };


        const url = "https://npln.ir/api/v1/app/products?page=" + offset + "&name=" + name;

        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_MDF_COLOR, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};



export const getDetailsMdfColor = (access_token, ids) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/app/product?product_id=" + ids;
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_DETAILS_MDF_COLOR, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};


export const SetMDFlist = (access_token, ids) => {

    let Header = {
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
    };

    var formdata = new FormData();
    formdata.append("product_id", ids);


    var requestOptions = {
        method: 'POST',
        headers: Header,
        body: formdata,
    };

    return fetch("https://npln.ir/api/v1/user/add-product", requestOptions)
        .then(response => response.json())
        .then(res => {
            // console.log(res);


            return res;
        })

        .catch(error => console.log('error', error));
};


export const DeleteMDFcolor = (access_token, ids) => {

    let Header = {
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
    };

    var formdata = new FormData();
    formdata.append("product_id", ids);


    var requestOptions = {
        method: 'POST',
        headers: Header,
        body: formdata,
    };

    return fetch("https://npln.ir/api/v1/user/delete-products", requestOptions)
        .then(response => response.json())
        .then(res => {
            //console.log(res);


            return res;
        })

        .catch(error => console.log('error', error));
};




export const getListMdfColor = (access_token) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/user/save-products";
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_LIST_MDF_COLOR, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};





export const SetForm = (access_token,
    idorder,
    idgroup,
    Height,
    Width,

    counter,
    up_rotation,
    length_one,
    length_two,
    width_one,
    width_two,
    discription,
    ids,
    idproduct,
    right_rotation,
    UP_N,
    UP_F,
    UP_SH,
    Down_N,
    Down_F,
    Down_SH,
    Right_N,
    Right_F,
    Right_SH,
    Left_N,
    Left_F,
    Left_SH,


    Radio1,
    Radio2,
    Radio3,
    white,



) => {

    return async (dispatch) => {


        const Header = {

            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        }


        var formdata = new FormData();
        formdata.append("order_id", idorder);
        formdata.append("group_id", idgroup);
        formdata.append("width", Width);
        formdata.append("height", Height);
        formdata.append("count", counter);
        formdata.append("rotate_status", up_rotation);
        formdata.append("description", discription);
        formdata.append("length_one", length_one);
        formdata.append("length_two", length_two);
        formdata.append("width_one", width_one);
        formdata.append("width_two", width_two);

        // formdata.append("right_rotation", right_rotation);
        // formdata.append("up_n", UP_N);
        // formdata.append("up_f", UP_F);
        // formdata.append("up_sh", UP_SH);
        // formdata.append("down_n", Down_N);
        // formdata.append("down_f", Down_F);
        // formdata.append("down_sh", Down_SH);
        // formdata.append("right_n", Right_N);
        // formdata.append("right_f", Right_F);
        // formdata.append("right_sh", Right_SH);
        // formdata.append("left_n", Left_N);
        // formdata.append("left_f", Left_F);
        // formdata.append("left_sh", Left_SH);
        // formdata.append("color_strip", Radio1);
        // formdata.append("width_strip", Radio2);
        // formdata.append("height_strip", Radio3);
        // formdata.append("white", white);



        var requestOptions = {
            method: 'POST',
            headers: Header,
            body: formdata,
        };

        return fetch("https://npln.ir/api/v1/order/add-slice", requestOptions)
            .then(response => response.json())
            .then(res => {
                //console.log(res);

                const data = res
                dispatch({ type: SEND_FORM, data });
                return res;
            })

            .catch(error => console.log('error', error));
    };
}



export const SetEditForm = (access_token,
    id,
    Height,
    Width,
    counter,
    up_rotation,
    length_one,
    length_two,
    width_one,
    width_two,
    discription

) => {

    return async (dispatch) => {


        const Header = {

            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        }


        var formdata = new FormData();
        formdata.append("slice_id", id);
        formdata.append("width", Width);
        formdata.append("height", Height);
        formdata.append("count", counter);
        formdata.append("rotate_status", up_rotation);
        formdata.append("description", discription);
        formdata.append("length_one", length_one);
        formdata.append("length_two", length_two);
        formdata.append("width_one", width_one);
        formdata.append("width_two", width_two);


        var requestOptions = {
            method: 'POST',
            headers: Header,
            body: formdata,
        };

        return fetch("https://npln.ir/api/v1/order/edit-slice", requestOptions)
            .then(response => response.json())
            .then(res => {
                //console.log(res);

                const data = res
                dispatch({ type: SEND_EDIT_FORM, data });
                return res;
            })

            .catch(error => console.log('error', error));
    };
}







export const getMdfimage = (access_token, ids) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/order/slice?slice_id=" + ids;
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_IMAGE_MDF, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};
























export const getAllListmdf = (access_token, ids) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/order/slices?order_id=" + ids;
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_ALL_LIST_MDF, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};




export const DeleteMDFList = (access_token, ids) => {

    let Header = {
        Accept: "application/json",
        Authorization: "Bearer " + access_token,
    };

    var formdata = new FormData();
    formdata.append("slice_id", ids);


    var requestOptions = {
        method: 'POST',
        headers: Header,
        body: formdata,
    };

    return fetch("https://npln.ir/api/v1/order/delete-slice", requestOptions)
        .then(response => response.json())
        .then(res => {
            //console.log(res);


            return res;
        })

        .catch(error => console.log('error', error));
};










export const SetCaht = (access_token, ids, typed, file) => {

    return async (dispatch) => {

        const Header = {
            'Accept': 'application/json',
            'Content-Type': "multipart/form-data",
            Authorization: "Bearer " + access_token,
        }

        const formData = new FormData();
        formData.append('order_id', ids);
        formData.append('type', typed);
        if (typed == "text") {

            formData.append('msg', file)
        } else {
            const fileName = file.split('/').pop();
            const fileType = fileName.split('.').pop();
            // console.log([fileName, file, fileType]);
            formData.append('msg', {
                uri: file,
                name: fileName,
                type: `application/${fileType}`
            });
        }



        // formData.append('msg', file)

       
        const url = "https://npln.ir/api/v1/order/message/send";
        return axios({
            method: "POST",
            url: url,
            headers: Header,
            data: formData
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: SEND_CHAT, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};





export const SetCahtWeb = (access_token, typed, file, ids) => {

    return async (dispatch) => {


        const Header = {
            'Accept': 'application/json',
            'Content-Type': "multipart/form-data",
            Authorization: "Bearer " + access_token,
        }

        const formData = new FormData();


        //    console.log([typed,file,ids]);
        formData.append('type', typed);
        formData.append('msg', file)
        formData.append('order_id', ids)
        const url = "https://npln.ir/api/v1/order/message/send";
        return axios({
            method: "POST",
            url: url,
            headers: Header,
            data: formData
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: SEND_CHAT, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};






export const getChat = (access_token, ids) => {

    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };

        // const uploading=
        //     (progressEvent) => {
        //         let percentComplete = progressEvent.loaded / progressEvent.total
        //         percentComplete = parseInt(percentComplete * 100);
        //         console.log(percentComplete);
        //         updateProgress(percentComplete)
        // }

        const url = "https://npln.ir/api/v1/order/message/messages?order_id=" + ids;
        return axios({
            method: "get",
            url: url,
            headers: Header,
            // onUploadProgress:uploading 
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_CHAT, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};



export const SetCahtTicketWeb = (access_token, typed, file, ids) => {

    return async (dispatch) => {

        const Header = {
            'Accept': 'application/json',
            'Content-Type': "multipart/form-data",
            Authorization: "Bearer " + access_token,
        }

        const formData = new FormData();


        formData.append('type', typed);
        formData.append('msg', file)
        formData.append('ticket_id', ids);
        const url = "https://npln.ir/api/v1/app/ticket/send-message";
        return axios({
            method: "POST",
            url: url,
            headers: Header,
            data: formData
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: SEND_CHAT_TICKET, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};


export const SetCahtTicket = (access_token, typed, file, ids) => {

    return async (dispatch) => {

        const Header = {
            'Accept': 'application/json',
            'Content-Type': "multipart/form-data",
            Authorization: "Bearer " + access_token,
        }

        const formData = new FormData();


        if (typed == "text") {
            formData.append('msg', file)
        } else {
            const fileName = file.split('/').pop();
            const fileType = fileName.split('.').pop();
            console.log([fileName, file, fileType]);
            formData.append('msg', {
                uri: file,
                name: fileName,
                type: `application/${fileType}`
            });
        }


        formData.append('type', typed);
        // formData.append('msg', file)
        formData.append('ticket_id', ids);
        const url = "https://npln.ir/api/v1/app/ticket/send-message";
        return axios({
            method: "POST",
            url: url,
            headers: Header,
            data: formData
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: SEND_CHAT_TICKET, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};



export const getChatTicket = (access_token, ids) => {

    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/app/ticket/messages?ticket_id=" + ids;
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                //console.log(data);
                dispatch({ type: GET_CHAT_TICKET, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};


export const getfinalListmdf = (access_token, ids) => {
    return async (dispatch) => {

        let Header = {
            Accept: "application/json",
            Authorization: "Bearer " + access_token,
        };
        const url = "https://npln.ir/api/v1/order/order?order_id=" + ids;
        return axios({
            method: "get",
            url: url,
            headers: Header,
        })

            .then(function (response) {
                //console.log(response);
                const resData = response;
                const data = resData.data;
                // console.log(data);
                dispatch({ type: GET_FINAL_LIST_MDF, data });
                return response;
            })
            .catch(function (error) {
                console.log(error.name);
                console.log(error.message);
                console.log(error);
            });
    };
};





